<template>
  <b-toast id="toast-selfie" :auto-hide-delay="7500" toaster="b-toaster-top-center toast-selfie">
    <div class="d-flex">
      <div class="mr-3">
        <Icon name="infoCircle" width="32" class="icon-circle"/>
      </div>
      <div class="text-left" v-html="message"></div>
    </div>
  </b-toast>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "ToastSelfie",
  computed: {
    ...mapGetters('checkin', [
      'privacy',
    ]),
    message() {
      if (this.privacy && this.privacy.pre_selfie_text) return this.privacy.pre_selfie_text
      return this.$t('notifications.info_selfie')
    }
  },
  methods: {
    show() {
      this.$bvToast.show('toast-selfie')
    },
    hide() {
      this.$bvToast.hide('toast-selfie')
    }
  }
}
</script>